import { PERFORMANCE, PERFORMANCE_ANALYTICS } from "lib/constants";
import { postAPICall, getAPICall } from "../lib/callApi";

export const fetchPerformance = async (payload) => {
  const data = await postAPICall(PERFORMANCE, true, payload);
  return data;
};

const convertArrToSearchParamsStr = (arr) =>
  arr.reduce((groupedIds, obj) => (groupedIds ? `${groupedIds},${obj.id}` : obj.id), "");

export const fetchPerformanceAnalytics = async (timeframe, offset, modalFilters = {}) => {
  const searchParams = {
    timeframe,
    offset,
    ...modalFilters,
  };

  // convert for backend consumption
  if (searchParams.location) {
    searchParams.location = convertArrToSearchParamsStr(searchParams.location);
  }
  if (searchParams.reportsTo) {
    searchParams.reportsTo = convertArrToSearchParamsStr(searchParams.reportsTo);
  }
  if (searchParams.role) {
    searchParams.role = convertArrToSearchParamsStr(searchParams.role);
  }
  if (searchParams.team) {
    searchParams.team = convertArrToSearchParamsStr(searchParams.team);
  }
  if (searchParams?.user?.length) {
    searchParams.user = convertArrToSearchParamsStr(
      searchParams.user.map((user) => ({ id: user.userCompanyLinkId }))
    );
  }

  const searchStr = new URLSearchParams(searchParams).toString();

  try {
    const data = await getAPICall(`${PERFORMANCE_ANALYTICS}?${searchStr}`, true);
    return data;
  } catch (err) {
    return {
      success: false,
    };
  }
};
